<div
	class="w-[88.5%] m-auto flex flex-col justify-between items-center min-h-full pb-3"
>
	<div class="w-full">
		<div class="flex ltr:justify-end rtl:justify-start">
			<a
				matSuffix
				mat-icon-button
				[mat-dialog-close]="false"
				class="w-[21px] h-[21px] rounded border-2 mb-[18px] flex justify-center"
			>
				<img class="m-auto" src="./assets/images/close-square.svg" alt="" />
			</a>
		</div>
		<div
			class=" grid {{
				uploudedImages.length > 0 ? 'md:grid-cols-3' : 'md:grid-cols-1'
			}} gap-3 "
		>
			<ng-container *ngIf="uploudedImages?.length">
				<div
					class="relative text-center"
					*ngFor="let image of renderdImages; let i = index"
				>
					<span
						class="absolute top-3 rtl:left-3 ltr:right-3 cursor-pointer"
						(click)="deleteImage(i)"
					>
						<a
							matSuffix
							mat-icon-button
							class="w-[21px] h-[21px] rounded-full border-2 border-solid border-off-white text-off-white mb-[18px] flex justify-center"
						>
							<mat-icon class="text-xs font-bold mb-4">close</mat-icon>
						</a>
						<!-- <img src="" alt="" /> -->
					</span>
					<img class="w-full rounded-[12px] bg-contain" [src]="image" alt="" />
				</div>
			</ng-container>
			<div
				*ngIf="uploudedImages.length < 5"
				class="text-center rounded-[6px] h-full border-[#D9DBE9] border-dashed pb-[16px] mb-[18px] flex flex-col items-center justify-center"
			>
				<button class="mt-[18px] mb-12px">
					<label class="custom-file-upload cursor-pointer">
						<input
							class="cursor-pointer"
							type="file"
							multiple
							accept="image/png, image/jpeg, image/jpg"
							(change)="fileChangeEvent($event)"
						/>
						<img class="m-auto" src="./assets/images/upload.svg" alt="" />
						<h1 class="text-link text-font-16 font-normal leading-[24px] m-0">
							{{ 'ACTIONS.UPLOAD_IMG' | translate }}
						</h1>
						<div class="mt-[6px]">
							<p class="text-medium-gray text-font-12 inline-block">
								{{ 'GALLERY.MAX_SIZE_FOR_EACH' | translate }}
							</p>
							<span class="text-medium-gray text-font-12">,</span>
							<p class="text-medium-gray text-font-12 inline-block">
								{{ 'GALLERY.MAX_GALLERY' | translate }}
							</p>
						</div>
					</label>
				</button>
			</div>
		</div>

		<small *ngIf="sizeError" class="text-red-error">
			{{ 'ERROR_MESSAGES.IMAGE_SIZE' | translate }}
		</small>
		<small *ngIf="maxNumber" class="text-red-error">
			{{ 'ERROR_MESSAGES.MAX_IMAGE_NUMBER' | translate }}
		</small>
	</div>

	<div class="w-full">
		<button
			mat-button
			[disabled]="!uploudedImages?.length"
			(click)="uploadImage(0)"
			class="w-100 bg-gradient text-white w-full rounded-[6px] mt-4"
		>
			{{ 'ACTIONS.UPLOAD_IMG' | translate }}
		</button>
		<button
			class="w-full mt-3 text-medium-gray bg-transparent border border-solid border-light-grey"
			[mat-dialog-close]="false"
			mat-button
		>
			{{ 'ACTIONS.CANCEL' | translate }}
		</button>
	</div>
</div>
